<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageGallery @toggleImage="onToggleImage" :showImage="showAssetInfo" overlay>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">    
                <div class="image"><transition name="fade" mode="out-in" appear><img :src="require('@/assets/images/' + assets[currentAsset].image)" alt=""></transition></div>                  
                  <div class="asset-info" v-if="currentAsset !== -1" :class="showAssetInfo ? 'show' : ''">                        
                        <p class="asset-name">Clubs</p>
                        <div class="asset-items">
                            <button 
                                v-for="(asset, id) in assets"
                                @click="currentAsset = id;"
                                :key="id"
                                :class="[currentAsset === id ? 'active' : '']"
                            />
                        </div>
                        <div class='linear'>
                            <LinearButton dark back @click="goBack"></LinearButton>
                            <LinearButton dark @click="goForward"></LinearButton>
                        </div>
                    </div>       
            </div>
        </div>
    </template>
    </PageGallery>    
  </div>
</template>

<script>
import PageGallery from "@/patterns/PageGallery.vue";
import LinearButton from "@/patterns/LinearButton.vue";
export default {
  name: "ClubsPhotoGallery",
  components: {LinearButton, PageGallery },
  data: () => ({
    scrollContent: false, 
    currentAsset:0,
    showAssetInfo:true,
    assets:[
        {
            display_name:"Modelo Club Bar",
            image:"photo_gallery/1_clubs_modelo-club-bar.jpg",
        },
        {
            display_name:"Modelo Club Bar",
            image:"photo_gallery/2_clubs_modelo-club-bar-2.jpg",
        },
        {
            display_name:"Back Bar",
            image:"photo_gallery/3_clubs_back-bar.jpg",
        },
        {
            display_name:"San Manuel Bar",
            image:"photo_gallery/4_clubs_san-manuel-bar.jpg",
        },
        {
            display_name:"Back Bar Dark",
            image:"photo_gallery/5_clubs_back-bar-dark.jpg",
        },
        {
            display_name:"Twitch Lounge",
            image:"photo_gallery/6_clubs_twitch-lounge.jpg",
        },
        {
            display_name:"Modelo Side",
            image:"photo_gallery/7_clubs_modelo-side.jpg",
        },
        {
            display_name:"Modelo Bar Side",
            image:"photo_gallery/8_clubs_modelo-bar-side.jpg",
        },
        {
            display_name:"Modelo Club Seating",
            image:"photo_gallery/9_clubs_modelo-club-seating.jpg",
        },
        {
            display_name:"Modelo Club Close Up",
            image:"photo_gallery/10_clubs_modelo-club-close-up.jpg",
        },
        {
            display_name:"Modelo Club Bar Close Up",
            image:"photo_gallery/11_clubs_modelo-club-bar-close-up2.jpg",
        },
        {
            display_name:"Back Bar Light",
            image:"photo_gallery/14_clubs_back-bar-light.jpg",
        }, 
        {
            display_name:"Club Ceiling",
            image:"photo_gallery/15_clubs_club-ceiling.jpg",
        }, 
        {
            display_name:"Twitch Lounge",
            image:"photo_gallery/16_clubs_twitch-lounge2.jpg",
        }, 
        {
            display_name:"Torch Side View",
            image:"photo_gallery/17_clubs_torch-side-view.jpg",
        }, 
        {
            display_name:"Lanai Open",
            image:"photo_gallery/18_clubs_lanai-open.jpg",
        }, 
        {
            display_name:"Lanai Closed",
            image:"photo_gallery/19_clubs_lanai-closed.jpg",
        }, 
        {
            display_name:"ETFE Roof",
            image:"photo_gallery/20_clubs_etfe-roof.jpg",
        },        
    ]
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    goBack() {
        this.currentAsset = this.currentAsset - 1;
        if(this.currentAsset < 0) {
            this.currentAsset = this.assets.length - 1;
        }
    },
    goForward() {
        this.currentAsset = this.currentAsset + 1;
        if(this.currentAsset == this.assets.length) {
            this.currentAsset = 0;
        }
    },
    venueSelected(id) {
        this.currentAsset = id;
        this.showAssetInfo = true; 
    },
    onToggleImage(showImage) {
        this.showAssetInfo = showImage;
    },
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.linear {
    position: relative;
    margin-top:60px;
}
.asset-info {
    position: absolute;
    left:60px;
    bottom:130px;
    transition: transform 0.25s cubic-bezier(1, 0.5, 0.8, 1);
    transform:translateY(calc(100% + 130px));
    .asset-name {
        color: #FFFFFF;
        font-family: 'Gotham';
        font-size: 2rem;
        font-weight: 900;
        letter-spacing: 0;
        line-height:1;
        text-transform:uppercase;
    }
    .asset-content {
        color: #FFF;
        font-family: 'Montserrat';
        font-size: 1rem;
        letter-spacing: 0;
        line-height: 1.7;
        max-width: 640px;
    }
    .asset-items {
        font-size: 0;
        margin-top:25px;
        button {
            cursor: pointer;
            width:40px;
            height:6px;
            background-color: #4B4B4D;
            border:none;
            outline:none;
            transition: background-color 0.25s cubic-bezier(1, 0.5, 0.8, 1);
            &:not(last-child) {
                margin-right:5px;
            }
            &.active {
                background-color: #fff;;
            }
        }
    }
    &.show {
        transition-delay: 0.2s;
        transform:translateY(0);
    }
}
.selector {    
    position: relative;    
    width: 100%;
}
.view-asset {  
  font-size: 0.8em;    
  margin-top:30px;
}
a {    
    color: #FFF;
    font-family: "Gotham";
    font-weight:bold;
    font-size: 0.8em;
    text-transform: uppercase;        
    text-decoration: none;
    img {
        margin-right:15px;
    }
    img, span {
        vertical-align: middle;
    }
}
</style>